const RoutePath = {
    LOGIN: "/",
    DASHBOARD: "/dashboard",

    KAMBING: "/kambing",
    KAMBING_ADD: "/kambing/add",
    KAMBING_EDIT: "/kambing/edit",
    KAMBING_EDIT_ID: "/kambing/edit/:id",
    KAMBING_VIEW: "/kambing/view",
    KAMBING_VIEW_ID: "/kambing/view/:id",
    KAMBING_VIEW_ID_CERTIFICATE: "/kambing/view/:id/certificate",
    KAMBING_VIEW_ID_FAMILYTREE: "/kambing/view/:id/family_tree",
    KAMBING_VIEW_ID_GALLERIES: "/kambing/view/:id/galleries",
    KAMBING_VIEW_ID_LOGS: "/kambing/view/:id/logs",
    // KAMBING_LACK_OF_INFORMATION: "/kambing/lack-of-information",
    KAMBING_SOLD: "/kambing/sold",

    SECTION: "/section",
    SECTION_ADD: "/section/add",
    SECTION_EDIT: "/section/edit",
    SECTION_TYPE: "/section/type",
    SECTION_TYPE_ADD: "/section/type/add",
    SECTION_TYPE_EDIT: "/section/type/edit",

    COUNTRY: "/country",
    COUNTRY_ADD: "/country/add",
    COUNTRY_EDIT: "/country/edit",

    ADMIN: "/admin",
    ADMIN_ADD: "/admin/add",
    ADMIN_EDIT: "/admin/edit",
    ADMIN_VENDOR: "/admin/vendor",

    VENDOR: "/vendor",
    VENDOR_ADD: "/vendor/add",
    VENDOR_EDIT: "/vendor/edit",

    COLOR: "/color",
    GOAT_TYPE: "/goat-type",
    GRADE: "/grade",
    SUPPLIER: "/supplier",
    OWNER: "/owner",
    GOAT_BIRTH_TYPE: "/goat-birth-type",
    FAMILY_NAME: "/family-name",

    GOAT_PEN: "/goat-pen",
    GOAT_PEN_ADD: "/goat-pen/add",
    GOAT_PEN_EDIT: "/goat-pen/edit",

    FEEDING: "/feeding",
    FEEDING_LOG: "/feeding/log/:goat_pen_id",

    FOOD: "/food",
    FOOD_ADD: "/food/add",
    FOOD_EDIT: "/food/edit",

    BUNKER: "/bunker",
    BUNKER_ADD: "/bunker/add",
    BUNKER_EDIT: "/bunker/edit",
    BUNKER_LOG: "/bunker/log/:id",

    MATING_PREPARATION: "/mating/preparation",
    MATING_SCHEDULE: "/mating/schedule",
    MATING_SCHEDULE_ID: "/mating/schedule/:id",

    MATING_PREPARATIONV2: "/mating/preparation-v2",
    MATING_SCHEDULEV2: "/mating/schedule-v2",
    MATING_SCHEDULE_IDV2: "/mating/schedule-v2/:id",
    MATING_FINISHED: "/mating/finished",
    MATING_HISTORY: "/mating/history",
    MATING_HISTORY_DETAIL: "/mating/history/:id",

    DEAD: "/dead",
    DEAD_APPROVAL: "/dead/approval",
    LIST_DEAD_GOAT: "/dead/dead-goat",
    UPLOAD_DEATH_CERTIFICATE: "/dead/upload-certificate",

    CHANGE_PASSWORD: "/change-password",
    RESET_PASSWORD: "/reset-password/:token",

    CERTIFICATE: "/certificate/:id",
    GOAT_CARD: "/goat-card/:id",
    QR_LANDING_PAGE: "/scan-goat-card/:id",

    REPORT: "/report",
    REPORT_GENERAL: "/report/general",
    REPORT_STOCK: "/report/stock",
    // REPORT_SALE: "/report/sale",
    // REPORT_SICK: "/report/sick",
    // REPORT_DEAD: "/report/dead",
    REPORT_MARRIAGE_JOURNAL: "/report/marriage-journal",
    REPORT_MARGA: "/report/marga",

    MENU_AUTHORIZATION: "/menu-authorization",
    GLOBAL_SETTING: "/global-setting",
}

export default RoutePath;